const EditIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H8.25C8.5575 0.9375 8.8125 1.1925 8.8125 1.5C8.8125 1.8075 8.5575 2.0625 8.25 2.0625H6.75C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V9.75C15.9375 9.4425 16.1925 9.1875 16.5 9.1875C16.8075 9.1875 17.0625 9.4425 17.0625 9.75V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625Z"
        fill="#535353"
      />
      <path
        d="M6.37549 13.2675C5.91799 13.2675 5.49799 13.1025 5.19049 12.8025C4.82299 12.435 4.66549 11.9025 4.74799 11.34L5.07049 9.08251C5.13049 8.64751 5.41549 8.08501 5.72299 7.77751L11.633 1.86751C13.1255 0.375013 14.6405 0.375013 16.133 1.86751C16.9505 2.68501 17.318 3.51751 17.243 4.35001C17.1755 5.02501 16.8155 5.68501 16.133 6.36001L10.223 12.27C9.91549 12.5775 9.35299 12.8625 8.91799 12.9225L6.66049 13.245C6.56299 13.2675 6.46549 13.2675 6.37549 13.2675ZM12.428 2.66251L6.51799 8.57251C6.37549 8.71501 6.21049 9.04501 6.18049 9.24001L5.85799 11.4975C5.82799 11.715 5.87299 11.895 5.98549 12.0075C6.09799 12.12 6.27799 12.165 6.49549 12.135L8.75299 11.8125C8.94799 11.7825 9.28549 11.6175 9.42049 11.475L15.3305 5.56501C15.818 5.07751 16.073 4.64251 16.1105 4.23751C16.1555 3.75001 15.9005 3.23251 15.3305 2.65501C14.1305 1.45501 13.3055 1.79251 12.428 2.66251Z"
        fill="#535353"
      />
      <path
        d="M14.8877 7.37249C14.8352 7.37249 14.7827 7.36499 14.7377 7.34999C12.7652 6.79499 11.1977 5.22749 10.6427 3.25499C10.5602 2.95499 10.7327 2.64749 11.0327 2.55749C11.3327 2.47499 11.6402 2.64749 11.7227 2.94749C12.1727 4.54499 13.4402 5.81249 15.0377 6.26249C15.3377 6.34499 15.5102 6.65999 15.4277 6.95999C15.3602 7.21499 15.1352 7.37249 14.8877 7.37249Z"
        fill="#535353"
      />
    </svg>
  );
};

export default EditIcon;
